import LangEnum from '../../../../lang/LangEnum';
import { captureErrorInApm } from '../../../../lib/apm/utils/captureErrorInApm.util';
import snackbarStore from '../../../../stores/Snackbar.store';
import { useTranslation } from '../../../translation/TranslationContext';
import { useNetworkContext } from '../../contexts/network/network.context';
import { useUserHasOfflineDatabase } from '../../database/offlineDatabase/hooks/useUserHasOfflineDatabase';
import { OfflineStatus } from '../../domain/offlineOrder/offlineOrder.types';
import { useOfflineOrdersStore } from '../../stores/offlineOrders/offlineOrders.store';

const useSyncOfflineOrders = () => {
  const { translate } = useTranslation();
  const { handleMessage } = snackbarStore;

  const { userHasInternet } = useNetworkContext();
  const userHasOfflineDatabase = useUserHasOfflineDatabase();

  const offlineOrderStore = useOfflineOrdersStore();

  const validateIfCanSync = () => {
    if (!userHasOfflineDatabase) {
      return false;
    }

    if (!userHasInternet) {
      handleMessage({ message: translate(LangEnum.GLOBAL_INTERNET_UNAVAILABLE), type: 'error' });
      return false;
    }

    return true;
  };

  const syncOfflineOrder = async (offlineId: string) => {
    const canSync = validateIfCanSync();
    if (!canSync) {
      return;
    }

    try {
      const offlineOrder = await offlineOrderStore.syncOfflineOrder(offlineId);

      if (offlineOrder.status === OfflineStatus.ERROR_SYNCING) {
        const errorCode = offlineOrder.metadata?.errorMetadata?.errorMessage;
        handleMessage({
          type: 'error',
          message: translate(errorCode || LangEnum.OFFLINE_FEEDBACK_CANT_SYNC, {
            code: `${offlineOrder.code}*`,
          }),
        });
      } else {
        handleMessage({
          type: 'info',
          message: translate(LangEnum.OFFLINE_FEEDBACK_SYNC_SENT_WITH_SUCCESS),
        });
      }
    } catch (error: any) {
      captureErrorInApm.offlineError(error);

      console.error('syncOfflineOrder', { error });

      handleMessage({
        type: 'error',
        message: translate(LangEnum.API_EXCEPTION_ORDER_NOT_FOUND),
      });
    }
  };

  return { syncOfflineOrder };
};

export default useSyncOfflineOrders;
